import {combineReducers} from '@reduxjs/toolkit';
import {
    updateUsersEntitlementsSlice,
    updateUsersEntitlementsStateSlice,
    updateUsersEntitlementsUsersSlice,
} from 'src/modules/bulk-update/update-users-entitlements/select-entitlements-step';

import {groupsTabReducer} from './groups-tab';
import {usersGroupsSearchResultReducer} from './users-groups-search-result';

export const usersAndGroups = combineReducers({
    accountGroups: groupsTabReducer,
    updateUsersEntitlements: updateUsersEntitlementsSlice.reducer,
    updateUsersEntitlementsState: updateUsersEntitlementsStateSlice.reducer,
    updateUserEntitlementsUsers: updateUsersEntitlementsUsersSlice.reducer,
    userSearchResult: usersGroupsSearchResultReducer,
});
